import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { tokenStorage } from './utils/tokenStorage';
import { userTokenStore } from './utils/serviceTokenStore';
import { extractIPFromURL, getSavedPodIP } from './utils/helpers';


const root = ReactDOM.createRoot(document.getElementById('root'));

const oidcConfig = {
  authority: process.env.REACT_APP_AUTH_ISSUER,
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
  redirect_uri: `${window.location.origin}/${extractIPFromURL(window.location.href)??""}`,
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || window.location.href,
  scope: 'openid profile email',
  revokeTokensOnSignout: true,
  automaticSilentRenew: true,
  silent_redirect_uri:`${window.location.origin}/silent-check-sso.html`,
  onSigninCallback:(user)=>{
    if(user){
      userTokenStore.setToken(user.access_token);
    }
  },
  onSignoutCallback: () => {
    tokenStorage.clearTokens();
  },
}

root.render(
  <OidcAuthProvider {...oidcConfig}>
    <App />
  </OidcAuthProvider>
);
